import { render, staticRenderFns } from "./fanshu.vue?vue&type=template&id=14443f72&scoped=true&"
import script from "./fanshu.vue?vue&type=script&lang=js&"
export * from "./fanshu.vue?vue&type=script&lang=js&"
import style0 from "./fanshu.vue?vue&type=style&index=0&id=14443f72&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14443f72",
  null
  
)

export default component.exports